import { Link } from 'react-router-dom';
import '../../styles/CTASection.css'; // CTASection ki CSS

function CTASection() {
  return (
    <section className="cta-section-wrapper">
      {/* Animated Background Glows */}
      <div className="cta-bg-glow cta-bg-glow-1"></div>
      <div className="cta-bg-glow cta-bg-glow-2"></div>
      <div className="cta-bg-glow cta-bg-glow-3"></div>

      <div className="cta-container">
        <div className="cta-content-wrapper">
          {/* Badge */}
          <div className="cta-badge-wrapper">
            <span className="cta-badge-dot"></span>
            <span className="cta-badge">🚀 Get Started</span>
          </div>

          {/* Main Content */}
          <h2 className="cta-title">
            Ready to <span className="cta-title-highlight">Dominate</span> the Game?
          </h2>
          
          <p className="cta-description">
            Join thousands of athletes and teams already competing on VernaEvents. 
            Discover your next tournament, register your team, and start your 
            journey to victory today!
          </p>

          {/* Buttons */}
          <div className="cta-buttons-wrapper">
            <Link to="/events" className="cta-btn-primary">
              Explore Events
              <svg className="cta-btn-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
              </svg>
            </Link>
            <Link to="/about" className="cta-btn-secondary">
              Learn More
            </Link>
          </div>

          {/* Trust Badges */}
          <div className="cta-trust-wrapper">
            <span className="cta-trust-item">🔒 Secure Registration</span>
            <span className="cta-trust-item">✅ Verified Events</span>
            <span className="cta-trust-item">🏅 Certified Organizers</span>
            <span className="cta-trust-item">📱 24/7 Support</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CTASection;